export const loader = "LOADER";

export const server_api = () => {

    const storedUrl = localStorage.getItem('host');
   
     // If it exists, return the URL from localStorage
     if (storedUrl) {
       return storedUrl;
     }
   
     // Otherwise, return the default URL
    //  return 'http://192.168.29.22:8080';
     return 'https://uat.webdekho.cloud/mmb-api';
   };